module.exports = __webpack_public_path__ + "img/1547278659.3d414da8.jpg";